export interface AccessProject {
    access_request_upload_file: boolean;
    access_request_upload_version: boolean;
    access_request_write_comments: boolean;
    access_request_read_comments: boolean;
    access_request_change_status: boolean;
    access_request_edit_labels: boolean;
    access_request_upload_version_edit_labels: boolean;
    access_request_set_activate_file: boolean;
    access_request_edit_info: boolean;
    access_request_add_my_feedback: boolean;
    access_request_share_update_status: boolean
}

export const AccessProjectKeys = {
    UPLOAD_FILE: "access_request_upload_file",
    UPLOAD_VERSION: "access_request_upload_version",
    WRITE_COMMENTS: "access_request_write_comments",
    READ_COMMENTS: "access_request_read_comments",
    CHANGE_STATUS: "access_request_change_status",
    EDIT_LABELS: "access_request_edit_labels",
    EDIT_LABELS_UPLOAD_VERSION: "access_request_upload_version_edit_labels",
    SET_ACTIVE_FILES: "access_request_set_activate_file",
    EDIT_INFO: "access_request_edit_info",
    ADD_MY_FEEDBACK: "access_request_add_my_feedback",
    UPDATE_SHARE_STATUS: "access_request_share_update_status"
}
